/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Logs_No_Logs_DescriptionInputs */



/**
* | output |
* | --- |
* | "No audit logs match your current filters. Try adjusting your search criteria or filters." |
*
* @param {Audit_Logs_No_Logs_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_logs_no_logs_description = /** @type {((inputs?: Audit_Logs_No_Logs_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Logs_No_Logs_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Audit-Protokolle entsprechen Ihren aktuellen Filtern. Versuchen Sie, Ihre Suchkriterien oder Filter anzupassen.")
	return /** @type {LocalizedString} */ ("No audit logs match your current filters. Try adjusting your search criteria or filters.")
});